import { ItemsPerPage } from '../items-per-page';

export class ItemsPerPageBuilder {

    static fromJson(json): ItemsPerPage {
        return (json) ? new ItemsPerPage(
            json.itemsPerPage,
        ) : null;
    }
}
